import { memo } from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  SimpleShowLayout,
  useRecordContext,
  usePermissions,
} from 'react-admin';
import { withStyles } from '@mui/styles';
import { useParams } from 'react-router-dom';
import ProgramAccess from './ProgramAccess';
import WorkoutHistory from './WorkoutHistory';
import OnbordingQuestions from './OnbordingQuestions';
import ShowGrid from './ShowGrid';

const styles = () => ({
  tabContent: {
    padding: '30px 0 0 0',
  },
  tab: {
    flex: '1 1 auto',
    textAlign: 'center',
    width: '100px',
  },
});

const ShowGridWrapper = () => {
  const record = useRecordContext();
  const { permissions } = usePermissions();
  return <ShowGrid record={record} permissions={permissions} />;
};

const ShowCustomer = ({ classes, ...props }) => {
  const { id } = useParams();

  return (
    <Show {...props} actions={null}>
      <SimpleShowLayout>
        <ShowGridWrapper />
        <ProgramAccess userId={id} />
        <TabbedShowLayout>
          <Tab label="Workout History" className={classes.tab}>
            <WorkoutHistory userId={id} className={classes.tabContent} />
          </Tab>
          <Tab label="Onboarding Question Answers" className={classes.tab}>
            <OnbordingQuestions userId={id} className={classes.tabContent} />
          </Tab>
        </TabbedShowLayout>
      </SimpleShowLayout>
    </Show>
  );
};

export default memo(withStyles(styles)(ShowCustomer));
